import MailboxTableHeader from '@src/main/modules/messages/ui/mailbox/components/mailbox/table/MailboxTableHeader';
import { CustomFilterMeta } from '@src/main/modules/messages/ui/mailbox/views/mailbox/mailbox.types';
import { useMemo } from 'react';

interface UseMailboxTableHeaderParams {
  initialFilters: CustomFilterMeta;
  setFilters: (filters: CustomFilterMeta) => void;
  onExportExcel: () => void;
  onExportPdf: () => void;
}

export const useMailboxTableHeader = ({
  initialFilters,
  setFilters,
  onExportExcel,
  onExportPdf,
}: UseMailboxTableHeaderParams) =>
  useMemo(
    () => (
      <MailboxTableHeader
        onRefresh={() => window.location.reload()}
        onClearFilters={() => setFilters(initialFilters)}
        onExportExcel={onExportExcel}
        onExportPdf={onExportPdf}
        showExportButtons
      />
    ),
    [initialFilters, setFilters, onExportExcel, onExportPdf],
  );
